import * as React from 'react';
import { Link } from '@cian/ui-kit';
import { IconActionArrowUpRight16 } from '@cian/ui-kit-design-tokens/icons';
import clsx from 'clsx';
import * as style from './BasicInfoLink.css';

export interface IBasicInfoLinkProps {
  text: string;
  linkUrl: string;
  onClick?(): void;
  withIcon?: boolean;
  fontSize?: 'S' | 'M' | 'L';
  inline?: boolean;
}

export const BasicInfoLink: React.FC<IBasicInfoLinkProps> = props => {
  const { text, linkUrl, onClick, withIcon, fontSize, inline } = props;

  const [hovered, setHovered] = React.useState(false);

  const handleMouseEnter = React.useCallback(() => {
    setHovered(true);
  }, []);

  const handleMouseLeave = React.useCallback(() => {
    setHovered(false);
  }, []);

  return (
    <div
      className={clsx(style['container'], { [style['with-icon']]: withIcon })}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Link
        color="current_color"
        fontWeight="bold"
        target="_blank"
        onClick={onClick}
        href={linkUrl}
        fontSize={fontSize}
        inline={inline}
      >
        {text}
      </Link>
      {withIcon && hovered && (
        <div className={style['icon']}>
          <IconActionArrowUpRight16 color="current_color" />
        </div>
      )}
    </div>
  );
};
